import { NL_STRING } from "./index";

//const apiPath = 'http://10.56.11.3:80';
//const apiPath = 'http://localhost:80';
//const apiPath = 'http://2020.literatuurengeneeskunde.nl';
const apiPath = "http://databases.literatuurengeneeskunde.nl";
//const apiPath = 'http://localhost:80';

/**
 * Get the path to the api
 * @param {string} locale The locale of the current page
 * @param {string} database The database to get the data from
 * @param {string} dbType The type of data to get from the database
 * @returns {string} The path to the api
 */
export const getApiPath = (locale, database, dbType = false) => {
  const apiPath = "/api";
  const path = [apiPath, locale, database];
  if (dbType) {
    path.push(dbType);
  }
  return path.join("/");
};

/**
 * Get the path to the current page
 * @param {string} locale The locale of the current page
 * @param {string} path The path to the current page
 * @returns {string} The path to the current page
 */
export const localPath = (locale, path) => {
  return `/${locale}/${path}`;
};
